import { Table } from '@tmov/design-system';
import { WaveVariantB } from '@tmov/design-system/icons';
import { orderBy } from 'natural-orderby';
import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';

import { LoadingContainer } from '../../../../components/LoadingContainer';
import useTransportadoraData from '../hooks/useTransportadoraData';
import { getColumns } from './getColumns';
import { TableContainer } from './styles';

const TransportadoraTable = ({ clientes, filters }) => {
  const {
    transportadoraData,
    loadingTransportadoraData,
  } = useTransportadoraData({
    filters,
    clientes,
  });
  const [sorter, setSorter] = useState({
    transportadora: 'asc',
    lote: 'none',
    share: 'none',
    quantidadeMotoristas: 'none',
    aderencia: 'none',
  });
  const columns = getColumns();

  const currentSorter = useMemo(
    () => Object.keys(sorter).find(acessor => sorter[acessor] !== 'none'),
    [sorter]
  );

  const sortedTransportadoras = useMemo(
    () =>
      orderBy(
        transportadoraData,
        [
          transportadora => transportadora[currentSorter],
          transportadora => transportadora[currentSorter],
        ],
        sorter[currentSorter]
      ),
    [currentSorter, sorter, transportadoraData]
  );

  return (
    <TableContainer>
      {!loadingTransportadoraData ? (
        <Table
          rows={sortedTransportadoras}
          columns={columns}
          sorting={{
            sorter,
            updateSorter: setSorter,
          }}
        />
      ) : (
        <LoadingContainer height="10vh">
          <WaveVariantB size="60px" />
        </LoadingContainer>
      )}
    </TableContainer>
  );
};

TransportadoraTable.propTypes = {
  clientes: PropTypes.arrayOf(PropTypes.object).isRequired,
  filters: PropTypes.shape({
    periodo: PropTypes.arrayOf(PropTypes.object),
    handlePeriodo: PropTypes.func,
    produto: PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
    }),
    handleProduto: PropTypes.func,
    cidade: PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
    }),
    handleCidade: PropTypes.func,
    estado: PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
    }),
    handleEstado: PropTypes.func,
  }).isRequired,
};

export default TransportadoraTable;
